module.exports = __webpack_public_path__ + "img/asan2.6e28d089.jpeg";